import React from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "../TextError";
import "./styles.scss";

function IconRadioButton(props) {
  const {
    label,
    name,
    options,
    present,
    isRow,
    required,
    showOnlyActive,
    disabled,
    handleModal,
    handleChange,
    ...rest
  } = props;

  const handleModalClick = (e) => {
    handleModal(e);
  };
  const handleRadioChange = (e) => {
    handleChange(e);
  };

  return (
    <div className="">
      <label className="xs-lable-select white" required>
        {label}
        {required ? <span style={{ color: "red" }}>{` *`}</span> : null}
      </label>
      <div
        style={{
          display: !showOnlyActive ? "flex" : "",
          flexDirection: isRow ? "row" : "column",
          justifyContent: !showOnlyActive ? "space-between" : "",
          marginTop: "0.5em",
          marginBottom: "1em",
        }}
      >
        <Field name={name}>
          {({ field, form: { setFieldValue } }) => {
            return options.map((option) => {
              return (
                <div
                  key={option.key}
                  style={{ width: !showOnlyActive ? "45%" : "" }}
                  className="icon-radio-button"
                >
                  <input
                    type="radio"
                    id={option.key}
                    {...field}
                    {...rest}
                    disabled={disabled}
                    value={option.value}
                    checked={field.value === option.value}
                    onClick={(e) => handleModalClick(e)}
                    onChange={(e) => {
                      handleRadioChange(e);
                      setFieldValue(name, e.target.value);
                    }}
                  />

                  <label
                    className={`radio_label ${
                      field.value === option.value
                        ? "active_radio"
                        : `${showOnlyActive ? "hide" : ""}`
                    } ${disabled ? "disabled" : ""}`}
                    htmlFor={option.key}
                  >
                    <span
                      className="color-border"
                      style={{ backgroundColor: option.color }}
                    ></span>
                    {option.icon ? (
                      <img src={option.icon} alt={field.value} />
                    ) : null}
                    {option.key}
                  </label>
                </div>
              );
            });
          }}
        </Field>
        <ErrorMessage component={TextError} name={name} />
      </div>
    </div>
  );
}

export default IconRadioButton;
